// extracted by mini-css-extract-plugin
module.exports = {"counter":"Counter_counter__2lilZ","counterField":"Counter_counterField__1kb-q","button":"Counter_button__34jv_"};